import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import {
  ButtonContainer,
  MuteLaneMediaButton,
  BlinkingText,
} from './Styles';

const MuteLaneMedia = ({ iconOnly }) => {
  const {
    AuctionStore: { laneMediaMuted },
    UIStore: { handleToggleLaneMedia },
  } = useStores();

  const getButtonText = () => {
    if (iconOnly) return null;
    return laneMediaMuted ? 'Unmute Microphone' : 'Mute Microphone';
  };

  return (
    <>
      <ButtonContainer>
        {laneMediaMuted ? (
          <MuteLaneMediaButton onClick={handleToggleLaneMedia}>
            <BlinkingText blink>
              <i className="fa fa-microphone fa-2" aria-hidden="true" />
              {getButtonText()}
            </BlinkingText>
          </MuteLaneMediaButton>
        ) : (
          <MuteLaneMediaButton onClick={handleToggleLaneMedia}>
            <i className="fa fa-microphone-slash fa-2" aria-hidden="true" />
            {getButtonText()}
          </MuteLaneMediaButton>
        )}
      </ButtonContainer>
    </>
  );
};

MuteLaneMedia.defaultProps = {
  iconOnly: false,
};

MuteLaneMedia.propTypes = {
  iconOnly: PropTypes.bool,
};

export default observer(MuteLaneMedia);
